var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"HomeView"}},[_c('Hero'),_c('QuickView'),_c('Roadmap'),_c('Explore'),_c('img',{attrs:{"src":require("@/assets/background_homepage_footer.webp"),"alt":"background_homepage_footer","id":"background_homepage_footer"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }